module.exports = __webpack_public_path__ + "static/media/surveys-logo-lc.065dcf78.svg";